const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const assign = require('object-assign');
const _ = require('lodash');
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const Filters = FuzzyReaction.Components.Visualization.Filters;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const CastStore = require('../../stores/CastStore');
const InstructorStore = require('../../stores/CastStore');
const FormatModalitiesStore = require('../../stores/FormatModalitiesStore');
const CastManagementMixin = require('./components/CastManagementMixin');
const CastPreview = require('./components/CastPreview');
const CastActions = require('../../actions/CastManagementActions');
const {withRouter} = require('react-router-dom');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const CastLibrary = createReactClass({
    displayName: 'CastLibrary',
    mixins: [CastManagementMixin],

    getInitialState: function () {
        return {
            filters: {},
            currentPageData: [],
            workingResource: {},
            openDeactivateModal: false,
            instructors: [],
            formatModalities: [],
            formIsValid: false,
            openPreviewModal: false,
            openTranscodingWarningModal: false
        }
    },

    /**
     * Resource actions set up
     */
    resourceActions: new ResourceActions('casts'),

    /**
     * Resource retrieval options
     */
    getOptions: {
        modifiers: {
            include: ['instructor', 'modality', 'format', 'format_modality', 'tracks', 'created_at'],
            sort: {
                id: 'desc'
            },
            pagination: {
                per_page: 25
            },
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Resource push options
     */
    sendOptions: {
        modifiers: {
            include: [],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    /**
     * Set up filter selection options
     */
    durationFilters: {
        "5 Minutes": {target_duration: '=300'},
        "10 Minutes": {target_duration: '=600'},
        "20 Minutes": {target_duration: '=1200'},
        "30 Minutes": {target_duration: '=1800'},
        "45 Minutes": {target_duration: '=2700'},
        "60 Minutes": {target_duration: '=3600'}
    },

    /**
     * Map cast object properties to table columns
     */
    tableKeys: {
        "Cast ID": "id",
        "Content ID": "content_id",
        "Instructor": "instructor",
        "Cast Title": "title",
        "Format-Modality": "format_modality",
        "Duration": "duration",
        "Date Created ": "created_at",
        "Date Last Activated": "published_date"
    },

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        if (typeof modifiers !== 'undefined' && typeof modifiers.filters !== 'undefined') {
            this.setState(function (previousState) {
                const nextFilters = {};
                _.merge(nextFilters, modifiers.filters);
                previousState.filters = nextFilters;
                return previousState;
            }, function () {
                let requestFilters = this.state.filters;
                if (!('format_modality_id' in requestFilters)) {
                    requestFilters.format_modality_id = 'NOT_NULL';
                }
                // Merge modifiers with already present ones
                this.getOptions.modifiers = assign(this.getOptions.modifiers, {filters: requestFilters});
                this.resourceActions.listResource(this.getOptions);
            });
        } else {
            let requestFilters = this.state.filters;
            if (!('format_modality_id' in requestFilters)) {
                requestFilters.format_modality_id = 'NOT_NULL';
            }
            // Merge modifiers with already present ones
            this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {filters: requestFilters});

            this.resourceActions.listResource(this.getOptions);
        }
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        // Reset filters
        this.getOptions.modifiers.filters = {};

        this.requestTableData();
        this.requestInstructorData();
        this.requestFormatModalityData();

        CastStore.addChangeListener(this._castChange);
        InstructorStore.addChangeListener(this._instructorChange);
        FormatModalitiesStore.addChangeListener(this._formatModalityChange);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        CastStore.removeChangeListener(this._castChange);
        InstructorStore.removeChangeListener(this._instructorChange);
        FormatModalitiesStore.removeChangeListener(this._formatModalityChange);
    },

    /**
     * Handle changes in Instructor Store
     */
    _instructorChange: function () {
        this.setState({
            instructors: InstructorStore.getInstructors()
        });
    },

    /**
     * Handle changes in FormatModalitiesStore Store
     */
    _formatModalityChange: function () {
        this.setState({
            formatModalities: FormatModalitiesStore.getResourceListData()
        });
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _castChange: function () {
        this.setState({
            currentPageData: CastStore.getResourceListData(),
        });
    },

    /**
     * Request instructor data to populate filter
     */
    requestInstructorData: function () {
        const instructors = new ResourceActions('instructors');
        instructors.listResource({
            modifiers: {
                sort: {
                    name: 'asc'
                },
                pagination: {
                    per_page: '20'
                },
                others: {
                    raw: true,
                    show_deleted: true
                }
            },
            dataNode: 'data',
        });
    },

    /**
     * Request format/modality data to populate filter
     */
    requestFormatModalityData: function () {
        const formatModalities = new ResourceActions('format-modalities');
        formatModalities.listResource({
            modifiers: {
                sort: {
                    label: 'asc'
                },
                others: {
                    show_deleted: true
                }
            },
            dataNode: 'data',
        });
    },

    /**
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        console.log('fired action', action);
        switch (action) {
            case 'deactivate':
                this.setState({
                    openDeactivateModal: true,
                    workingResource: resource,
                    resourceOperation: action
                });
                break;
            case 'activate':
                resource.published_date = new Date()
                resource.deleted_at = null;
                this.resourceActions.updateResource(resource, this.sendOptions);
                break;
            case 'create':
                // Clear stored cast for a fresh start
                CastActions.clearStoredCast();

                this.props.history.push(`/cast-library/`);
                break;
            case 'edit':
                if (resource.is_pending) {
                    this.setState({
                        openTranscodingWarningModal: true,
                        workingResource: resource
                    });
                } else {
                    this.props.history.push(`/cast-library/${resource.id}`);
                }

                break;
            case 'preview':
                this.setState({
                    openPreviewModal: true,
                    workingResource: resource
                });
                break;
        }
    },

    /**
     * Fire the deactivate cast resource action
     */
    deactivateCast: function () {
        this.resourceActions.deactivateResource(this.state.workingResource, this.sendOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openCreateModal: false,
            openDeactivateModal: false,
            openPreviewModal: false,
            openTranscodingWarningModal: false,
            workingResource: {}
        });
    },

    /**
     * Build an object containing instructor filters
     *
     * @returns {{}}
     */
    instructorFilters: function () {
        const instructorFilters = {};
        this.state.instructors.forEach(function (instructor) {
            instructorFilters[instructor.name] = {
                'instructor_id': '[' + instructor.id.toString() + ']'
            };
        });

        return instructorFilters;
    },

    /**
     * Build an object containing format/modality filters
     *
     * @returns {{}}
     */
    formatModalityFilters: function () {
        const formatModalityFilters = {};
        this.state.formatModalities.forEach(function (formatModality) {
            formatModalityFilters[formatModality.label] = {
                'format_modality_id': '[' + formatModality.id.toString() + ']'
            };
        });

        return formatModalityFilters;
    },

    /**
     * Cast table options
     *
     * @returns {object}
     */
    tableOptions: function () {
        const toMinutesString = this.toMinutesString;

        return {
            actionableRows: true,
            actions: ['edit:primary', 'preview:primary', 'deactivate:warning'],
            actionsCallback: this.handleAction,
            hideSpinner: true,
            emptyText: 'No casts found.',
            mutators: {
                instructor: function (value) {
                    if (value) {
                        return value.name;
                    }

                    // If instructor was deleted
                    return 'Anonymous Instructor';
                },
                format_modality: function (value) {
                    if (value) {
                        return value.label;
                    }
                },
                duration: function (value, object) {
                    if (object.is_pending) {
                        return 'Transcoding pending.';
                    }

                    return toMinutesString(value);
                }
            }
        }
    },

    render: function () {
        const filters = [
            {
                label: 'Duration (All)',
                filters: this.durationFilters
            },
            {
                label: 'Format-Modality (All)',
                filters: this.formatModalityFilters()
            },
            {
                label: 'Instructor (All)',
                filters: this.instructorFilters()
            }
        ];

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="4">
                            <h1 className="page-header">Cast Library</h1>
                        </Column>

                        <Column grid="lg" size="8">
                            <Filters filters={filters} actionMethod={this.requestTableData}/>
                        </Column>
                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Cast Library'} options={this.tableOptions()}/>

                            <Paginator actionMethod={this.requestTableData}/>

                            <PerPageSelector actionMethod={this.requestTableData}/>

                        </Column>
                    </Row>
                </div>

                <Modal openWhen={this.state.openDeactivateModal}
                       title="Deactivate?" closeText="Close"
                       saveText="Deactivate" afterClose={this.closeModal}
                       beforeSave={this.deactivateCast}
                       afterSave={this.closeModal}>
                    <p>You’re about to deactivate a resource.</p>
                    <p>Continue with deactivating their accounts&#63;</p>
                </Modal>

                <Modal openWhen={this.state.openTranscodingWarningModal}
                       title="Transcoding is Pending"
                       afterClose={this.closeModal}
                       showButton="save"
                       saveText="OK"
                       afterSave={this.closeModal}>
                    <p>{this.state.workingResource.title} is currently being transcoded and can't be edited.</p>
                </Modal>

                <Modal openWhen={this.state.openPreviewModal}
                       title="Preview Cast"
                       afterClose={this.closeModal}
                       showButton="save"
                       saveText="Close"
                       afterSave={this.closeModal}
                       modalBodyClasses="cast-preview-modal">
                    <CastPreview key={'cast:' + this.state.workingResource.id} cast={this.state.workingResource}/>
                </Modal>

                <AddAction createResource={this.handleAction}/>
            </div>
        )
    },
});

module.exports = withRouter(CastLibrary);
